export const SUBSCRIPTIONS_COPY = {
  searchMore: 'Looking for new publishers to follow?',
  searchMoreLink: 'Search for them here',
};
